import * as R from 'ramda'

export const getPageParams = pages => {
  const filterQuery = new URLSearchParams()
  if (!R.isNil(pages?.rowsPerPage)) {
    filterQuery.append('pageSize', pages?.rowsPerPage)
  }

  if (!R.isNil(pages?.page)) {
    //NOTE: The table is 0-indexed but backend is 1-indexed
    filterQuery.append('pageIndex', Number(pages?.page) + 1)
  }

  return filterQuery.toString()
}

export const getGeneratedReportsFilters = filters => {
  const filterQuery = new URLSearchParams()
  if (!R.isNil(filters?.rowsPerPage)) {
    filterQuery.append('page_size', filters?.rowsPerPage)
  }

  if (!R.isNil(filters?.page)) {
    //NOTE: The table is 0-indexed but backend is 1-indexed
    filterQuery.append('page_index', Number(filters?.page) + 1)
  }

  if (!R.isNil(filters?.dateTo)) {
    filterQuery.append('to', filters?.dateTo)
  }

  if (!R.isNil(filters?.dateFrom)) {
    filterQuery.append('from', filters?.dateFrom)
  }

  return filterQuery.toString()
}
